import ReactGA from 'react-ga'
import ReactPixel from 'react-facebook-pixel'
import GA4React, { useGA4React } from 'ga-4-react'
import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'

const GA4CODE = 'G-S150GQ9K0J'
const PIXEL = '509263260378505'

type TrackType = 'pageview' | 'completeregistration'
const useTrackAnalytics = () => {
  const location = useLocation()
  const path = location.pathname
  const ga4React = useGA4React(GA4CODE)

  const track = useCallback(
    (type: TrackType) => {
      console.log('tracking', path, type)
      if (type === 'pageview') {
        ReactPixel.pageView()
        ga4React && ga4React.pageview(path)
      } else if (type === 'completeregistration') {
        ReactPixel.track('CompleteRegistration')
      } else {
        throw new Error(`Unrecognized track type ${type}`)
      }
      ReactPixel.track('CompleteRegistration')
      ga4React && ga4React.pageview(path)
    },
    [ga4React, path],
  )
  return track
}

const initializeAnalytics = () => {
  const ga4react = new GA4React(GA4CODE)
  ga4react.initialize()
  ReactPixel.init(PIXEL)
}

// const track = (type, info) => {
//   // console.log('analytics', type, info)
//   switch (type) {
//     case 'pageview':
//       // console.log('analytics pageview', info)
//       // ReactGA.pageview(info)
//       ReactPixel.track('PageView')
//       return
//     case 'completeregistration':
//       // console.log('analytics completeregistration', info)
//       ReactPixel.track('CompleteRegistration')
//       return
//     default:
//     // console.log(`unregnized analytics option ${type}`)
//   }
// }

export { ReactGA, ReactPixel, initializeAnalytics, useTrackAnalytics }
